(function () {
  if (window.__icpHealthcareInitialized) return;
  window.__icpHealthcareInitialized = true;

  function createListenerScope(owner, cleanupKey, initializedKey) {
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var cleanups = [];

    function on(target, eventName, handler, options) {
      if (!target) return;
      var listenerOptions = options;
      if (controller) {
        listenerOptions = Object.assign({}, options || {}, { signal: controller.signal });
      }
      target.addEventListener(eventName, handler, listenerOptions);
      cleanups.push(function () {
        target.removeEventListener(eventName, handler, options);
      });
    }

    // For teardown that isn't an event listener -- e.g. destroying a Swiper
    // instance or removing a MediaQueryList change handler.
    function addCleanup(fn) {
      if (typeof fn === 'function') cleanups.push(fn);
    }

    owner[cleanupKey] = function () {
      if (controller) {
        controller.abort();
      }
      cleanups.forEach(function (cleanup) {
        cleanup();
      });
      cleanups = [];
      delete owner[cleanupKey];
      if (initializedKey && owner.dataset) {
        delete owner.dataset[initializedKey];
      }
    };

    return { on: on, addCleanup: addCleanup };
  }

  function cleanupIcpElement(element) {
    ['__icpProductCleanup', '__icpFloatingAtcCleanup', '__icpCardCarouselCleanup'].forEach(function (cleanupKey) {
      if (typeof element[cleanupKey] === 'function') {
        element[cleanupKey]();
      }
    });
  }

  function cleanupIcpSection(container) {
    if (!container) return;
    cleanupIcpElement(container);
    container.querySelectorAll('[data-icp-product], [data-icp-floating-atc], .sa-icp-section, [data-icp-card-carousel]').forEach(cleanupIcpElement);
  }

  function initIcpProduct(root) {
    if (!root) return;
    if (root.dataset.icpProductInitialized === 'true') return;
    root.dataset.icpProductInitialized = 'true';
    var listeners = createListenerScope(root, '__icpProductCleanup', 'icpProductInitialized');

    var moneyFormat = root.dataset.moneyFormat || '';
    var moneyWithCurrencyFormat = root.dataset.moneyWithCurrencyFormat || '';
    var galleryHost = root.querySelector('.sa-icp-product__media');
    var galleryRoot = root.querySelector('media-gallery');
    var gallerySwiper = galleryRoot ? galleryRoot.querySelector('slide-with-thumbs') : null;
    var galleryPagination = root.querySelector('[data-icp-gallery-pagination]');
    var galleryDots = galleryPagination ? galleryPagination.querySelectorAll('[data-icp-gallery-dot]') : [];
    var galleryGotoTimer = null;
    var galleryControlFrame = null;
    var galleryControlBindings = [];
    var galleryControlsBound = false;

    listeners.addCleanup(function () {
      if (galleryGotoTimer) {
        window.clearTimeout(galleryGotoTimer);
        galleryGotoTimer = null;
      }
      if (galleryControlFrame) {
        window.cancelAnimationFrame(galleryControlFrame);
        galleryControlFrame = null;
      }
      if (gallerySwiper && gallerySwiper.globalSlide && typeof gallerySwiper.globalSlide.off === 'function') {
        galleryControlBindings.forEach(function (binding) {
          gallerySwiper.globalSlide.off(binding.eventName, binding.handler);
        });
      }
      galleryControlBindings = [];
      galleryControlsBound = false;
    });

    // Re-format prices client-side so Markets / currency switches are reflected.
    // Falls back to the server-rendered string when formatMoney is unavailable.
    function formatPrice(cents, withCurrency, fallback) {
      if (cents === undefined || cents === null || cents === '') return fallback || '';
      if (!window.Shopify || typeof window.Shopify.formatMoney !== 'function') return fallback || '';
      var format = withCurrency ? moneyWithCurrencyFormat : moneyFormat;
      if (!format) format = (window.cartStrings && window.cartStrings.money_format) || '';
      if (!format) return fallback || '';
      try {
        return window.Shopify.formatMoney(cents, format);
      } catch (error) {
        return fallback || '';
      }
    }

    var variantSelect = root.querySelector('[data-icp-variant-select]');
    var quantityInput = root.querySelector('[data-icp-quantity]');
    var quantityDisplay = root.querySelector('[data-icp-qty-display]');
    var quantityMinus = root.querySelector('[data-icp-qty-minus]');
    var quantityPlus = root.querySelector('[data-icp-qty-plus]');
    var variantOptions = root.querySelectorAll('[data-icp-variant-option]');
    var addCartButton = root.querySelector('[data-icp-add-cart]');
    var floatingAddCartButton = root.querySelector('[data-icp-floating-add-cart]');
    var buyButton = root.querySelector('[data-icp-buy-button]');
    var buyNowLinks = root.querySelectorAll('[data-icp-buy-now]');
    var stickyBuy = root.querySelector('[data-icp-sticky-buy]');
    var moreButton = root.querySelector('[data-icp-view-more]');
    var moreLabel = root.querySelector('[data-icp-more-label]');
    var priceEl = root.querySelector('[data-icp-price]');
    var comparePriceEl = root.querySelector('[data-icp-compare-price]');
    var stickyPriceEl = root.querySelector('[data-icp-sticky-price]');
    var floatingPriceEl = root.querySelector('[data-icp-floating-price]');

    function getQuantity() {
      var quantity = parseInt(quantityInput && quantityInput.value, 10);
      return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
    }

    function getSelectedOption() {
      if (!variantSelect) return null;
      return variantSelect.options[variantSelect.selectedIndex] || null;
    }

    function getVariantMediaId(option) {
      if (!option || !option.dataset) return '';
      return option.dataset.mediaId || root.dataset.icpSelectedMediaId || '';
    }

    function setActiveVariantButton(variantId) {
      variantOptions.forEach(function (button) {
        var isActive = button.dataset.variantId === String(variantId);
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    function refreshGallery() {
      if (!gallerySwiper || !gallerySwiper.globalSlide) return;
      if (typeof gallerySwiper.updateSlide === 'function') {
        gallerySwiper.updateSlide();
      }
      if (gallerySwiper.thumbnailSlide && typeof gallerySwiper.updateThumbSlide === 'function') {
        gallerySwiper.updateThumbSlide();
      }
    }

    function getGalleryActiveIndex(swiper) {
      if (!swiper) return 0;
      if (Number.isFinite(swiper.realIndex)) return swiper.realIndex;
      if (Number.isFinite(swiper.activeIndex)) return swiper.activeIndex;
      return 0;
    }

    function getGalleryActiveMediaId(swiper) {
      if (!swiper || !swiper.slides || !swiper.slides.length) return '';
      var activeSlide = swiper.slides[swiper.activeIndex];
      if (!activeSlide || !activeSlide.dataset) return '';
      return activeSlide.dataset.mediaId || '';
    }

    function syncGalleryPaginationState(mediaId, index) {
      if (!galleryDots.length) return;
      var activeIndex = Number.isFinite(index) ? index : getGalleryActiveIndex(gallerySwiper && gallerySwiper.globalSlide);
      var activeMediaId = mediaId || getGalleryActiveMediaId(gallerySwiper && gallerySwiper.globalSlide);
      if (activeMediaId) {
        galleryDots.forEach(function (button, dotIndex) {
          if (button.dataset && button.dataset.mediaId === activeMediaId) {
            activeIndex = dotIndex;
          }
        });
      } else if (gallerySwiper && gallerySwiper.globalSlide) {
        var activeSlide = gallerySwiper.globalSlide.slides && gallerySwiper.globalSlide.slides[gallerySwiper.globalSlide.activeIndex];
        if (activeSlide && activeSlide.dataset && !activeSlide.dataset.mediaId) {
          activeIndex = -1;
        }
      }
      if (activeIndex >= 0) {
        activeIndex = Math.max(0, Math.min(activeIndex, galleryDots.length - 1));
      }

      galleryDots.forEach(function (button, dotIndex) {
        var isActive = activeIndex >= 0 && dotIndex === activeIndex;
        button.classList.toggle('is-active', isActive);
        if (isActive) {
          button.setAttribute('aria-current', 'true');
        } else {
          button.removeAttribute('aria-current');
        }
      });
    }

    function syncGalleryNavigationState() {
      if (!gallerySwiper || !gallerySwiper.globalSlide) return false;
      var swiper = gallerySwiper.globalSlide;
      var isAtStart = swiper.isBeginning || swiper.activeIndex <= 0;
      if (galleryHost) {
        galleryHost.classList.toggle('sa-icp-gallery--at-start', isAtStart);
      }
      syncGalleryPaginationState(getGalleryActiveMediaId(swiper), getGalleryActiveIndex(swiper));
      return true;
    }

    function disableGalleryAutoplay() {
      if (!gallerySwiper || !gallerySwiper.globalSlide) return false;
      var swiper = gallerySwiper.globalSlide;
      if (swiper.autoplay) {
        if (typeof swiper.autoplay.stop === 'function') {
          swiper.autoplay.stop();
        }
        swiper.autoplay.start = function () {};
        swiper.autoplay.stop = function () {};
      }
      if (swiper.params) {
        swiper.params.autoplay = false;
        swiper.params.loop = false;
        swiper.params.rewind = false;
      }
      swiper.loop = false;
      return true;
    }

    function bindGalleryControls() {
      if (!gallerySwiper || !gallerySwiper.globalSlide || galleryControlsBound) return false;
      var swiper = gallerySwiper.globalSlide;
      if (typeof swiper.on !== 'function') return false;

      galleryControlsBound = true;
      disableGalleryAutoplay();
      syncGalleryNavigationState();

      var updateState = function () {
        syncGalleryNavigationState();
      };
      ['slideChange', 'update', 'reachBeginning', 'fromEdge', 'reachEnd', 'resize'].forEach(function (eventName) {
        swiper.on(eventName, updateState);
        galleryControlBindings.push({
          eventName: eventName,
          handler: updateState
        });
      });

      return true;
    }

    function ensureGalleryControls(attempt) {
      if (galleryControlsBound) return;
      if (bindGalleryControls()) return;
      if ((attempt || 0) >= 120) return;
      if (galleryControlFrame) return;
      galleryControlFrame = window.requestAnimationFrame(function () {
        galleryControlFrame = null;
        ensureGalleryControls((attempt || 0) + 1);
      });
    }

    function gotoGalleryIndex(index, attempt) {
      if (!gallerySwiper) return;
      var targetIndex = parseInt(index, 10);
      if (!Number.isFinite(targetIndex) || targetIndex < 0) return;
      if (galleryDots.length) {
        targetIndex = Math.min(targetIndex, galleryDots.length - 1);
      }
      var targetDot = galleryDots[targetIndex];
      if (targetDot && targetDot.dataset && targetDot.dataset.mediaId) {
        gotoGalleryMediaId(targetDot.dataset.mediaId, attempt);
        return;
      }

      if (gallerySwiper.globalSlide && typeof gallerySwiper.functionGoto === 'function') {
        gallerySwiper.functionGoto(targetIndex);
        refreshGallery();
        syncGalleryPaginationState('', targetIndex);
        return;
      }

      var nextAttempt = attempt || 0;
      if (nextAttempt >= 20) return;
      if (galleryGotoTimer) {
        window.clearTimeout(galleryGotoTimer);
      }
      galleryGotoTimer = window.setTimeout(function () {
        gotoGalleryIndex(targetIndex, nextAttempt + 1);
      }, 100);
    }

    function gotoGalleryMediaId(mediaId, attempt) {
      if (!gallerySwiper || !mediaId) return;

      var slides = gallerySwiper.querySelectorAll('.swiper-wrapper-preview .swiper-slide[data-media-id]');
      var targetIndex = -1;

      Array.prototype.forEach.call(slides, function (slide, index) {
        if (targetIndex !== -1) return;
        if (slide.dataset && slide.dataset.mediaId === mediaId) {
          targetIndex = index;
        }
      });

      if (targetIndex < 0) {
        var nextAttempt = attempt || 0;
        if (nextAttempt >= 20) return;
        if (galleryGotoTimer) {
          window.clearTimeout(galleryGotoTimer);
        }
        galleryGotoTimer = window.setTimeout(function () {
          gotoGalleryMediaId(mediaId, nextAttempt + 1);
        }, 100);
        return;
      }

      if (gallerySwiper.globalSlide && typeof gallerySwiper.functionGoto === 'function') {
        gallerySwiper.functionGoto(targetIndex);
        refreshGallery();
        syncGalleryPaginationState(mediaId, targetIndex);
        return;
      }

      var nextAttempt = attempt || 0;
      if (nextAttempt >= 20) return;
      if (galleryGotoTimer) {
        window.clearTimeout(galleryGotoTimer);
      }
      galleryGotoTimer = window.setTimeout(function () {
        gotoGalleryMediaId(mediaId, nextAttempt + 1);
      }, 100);
    }

    function syncGalleryFromSelectedVariant() {
      ensureGalleryControls();
      var selected = getSelectedOption();
      var mediaId = getVariantMediaId(selected);
      if (!mediaId) {
        mediaId = root.dataset.icpSelectedMediaId || '';
      }
      gotoGalleryMediaId(mediaId);
    }

    function setQuantity(value) {
      var nextQuantity = parseInt(value, 10);
      if (!Number.isFinite(nextQuantity) || nextQuantity < 1) {
        nextQuantity = 1;
      }
      if (quantityInput) {
        quantityInput.value = nextQuantity;
      }
      if (quantityDisplay) {
        quantityDisplay.textContent = nextQuantity;
      }
      if (quantityMinus) {
        quantityMinus.disabled = nextQuantity <= 1;
      }
      syncBuyNow({ updateGallery: false });
    }

    function syncBuyNow(options) {
      var shouldUpdateGallery = !options || options.updateGallery !== false;
      if (!variantSelect) return;
      var selected = getSelectedOption();
      var variantId = selected && selected.value;
      var available = selected && selected.dataset.available === 'true';
      var quantity = getQuantity();

      var priceText = selected
        ? formatPrice(selected.dataset.priceCents, false, selected.dataset.price)
        : '';
      var floatingPriceText = selected
        ? formatPrice(selected.dataset.priceCents, true, selected.dataset.floatingPrice || selected.dataset.price)
        : '';
      var compareText = selected
        ? formatPrice(selected.dataset.comparePriceCents, false, selected.dataset.comparePrice)
        : '';

      if (selected && priceEl) {
        priceEl.textContent = priceText || priceEl.textContent;
      }
      if (selected && comparePriceEl) {
        if (compareText) {
          comparePriceEl.textContent = compareText;
          comparePriceEl.hidden = false;
        } else {
          comparePriceEl.textContent = '';
          comparePriceEl.hidden = true;
        }
      }
      if (selected && stickyPriceEl) {
        stickyPriceEl.textContent = priceText || stickyPriceEl.textContent;
      }
      if (selected && floatingPriceEl) {
        floatingPriceEl.textContent = floatingPriceText || floatingPriceEl.textContent;
      }
      if (shouldUpdateGallery) {
        syncGalleryFromSelectedVariant();
      }

      if (addCartButton) {
        var returnTo = addCartButton.dataset.returnTo || '/cart';
        var addUrl = addCartButton.dataset.cartAddUrl || '/cart/add';
        if (available && variantId) {
          addCartButton.href = addUrl + '?id=' + encodeURIComponent(variantId) + '&quantity=' + encodeURIComponent(quantity) + '&return_to=' + encodeURIComponent(returnTo);
          addCartButton.classList.remove('is-disabled');
          addCartButton.removeAttribute('aria-disabled');
        } else {
          addCartButton.href = '#';
          addCartButton.classList.add('is-disabled');
          addCartButton.setAttribute('aria-disabled', 'true');
        }
      }

      if (floatingAddCartButton) {
        var floatingReturnTo = floatingAddCartButton.dataset.returnTo || '/cart';
        var floatingAddUrl = floatingAddCartButton.dataset.cartAddUrl || '/cart/add';
        if (available && variantId) {
          floatingAddCartButton.href = floatingAddUrl + '?id=' + encodeURIComponent(variantId) + '&quantity=' + encodeURIComponent(quantity) + '&return_to=' + encodeURIComponent(floatingReturnTo);
          floatingAddCartButton.classList.remove('is-disabled');
          floatingAddCartButton.removeAttribute('aria-disabled');
        } else {
          floatingAddCartButton.href = '#';
          floatingAddCartButton.classList.add('is-disabled');
          floatingAddCartButton.setAttribute('aria-disabled', 'true');
        }
      }

      if (buyButton) {
        var cartUrl = buyButton.dataset.cartUrl || '/cart';
        if (available && variantId) {
          buyButton.href = cartUrl + '/' + encodeURIComponent(variantId) + ':' + encodeURIComponent(quantity) + '?checkout';
          buyButton.classList.remove('is-disabled');
          buyButton.removeAttribute('aria-disabled');
        } else {
          buyButton.href = '#';
          buyButton.classList.add('is-disabled');
          buyButton.setAttribute('aria-disabled', 'true');
        }
      }

      buyNowLinks.forEach(function (link) {
        if (available && variantId) {
          link.href = (link.dataset.cartUrl || '/cart') + '/' + variantId + ':' + quantity + '?checkout';
          link.classList.remove('disabled');
          link.removeAttribute('aria-disabled');
        } else {
          link.href = '#';
          link.classList.add('disabled');
          link.setAttribute('aria-disabled', 'true');
        }
      });
    }

    if (variantSelect) {
      listeners.on(variantSelect, 'change', function () {
        setActiveVariantButton(variantSelect.value);
        syncBuyNow({ updateGallery: true });
      });
    }
    if (galleryPagination) {
      listeners.on(galleryPagination, 'click', function (event) {
        var target = event.target && event.target.closest ? event.target.closest('[data-icp-gallery-dot]') : null;
        if (!target || !galleryPagination.contains(target)) return;
        ensureGalleryControls();
        gotoGalleryMediaId(target.dataset.mediaId);
      });
    }
    variantOptions.forEach(function (button) {
      listeners.on(button, 'click', function () {
        var variantId = button.dataset.variantId;
        if (!variantId || !variantSelect) return;
        variantSelect.value = variantId;
        setActiveVariantButton(variantId);
        syncBuyNow({ updateGallery: true });
      });
    });
    [addCartButton, floatingAddCartButton, buyButton].forEach(function (button) {
      if (!button) return;
      listeners.on(button, 'click', function (event) {
        if (button.classList.contains('is-disabled') || button.getAttribute('aria-disabled') === 'true') {
          event.preventDefault();
        }
      });
    });
    if (quantityInput) {
      listeners.on(quantityInput, 'input', function () {
        setQuantity(quantityInput.value);
      });
      listeners.on(quantityInput, 'change', function () {
        setQuantity(quantityInput.value);
      });
    }
    if (quantityMinus) {
      listeners.on(quantityMinus, 'click', function () {
        setQuantity(getQuantity() - 1);
      });
    }
    if (quantityPlus) {
      listeners.on(quantityPlus, 'click', function () {
        setQuantity(getQuantity() + 1);
      });
    }
    if (moreButton) {
      moreButton.setAttribute('aria-expanded', 'false');
      listeners.on(moreButton, 'click', function () {
        var expanded = root.classList.toggle('is-expanded');
        moreButton.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        if (moreLabel) {
          moreLabel.textContent = expanded ? moreButton.dataset.lessText : moreButton.dataset.moreText;
        }
      });
    }

    if (stickyBuy) {
      var trigger = document.querySelector('[data-icp-sticky-trigger]');
      var productPanel = root.querySelector('[data-icp-product-panel]');

      function syncStickyBuy() {
        var triggerGone = true;
        var panelVisible = false;

        if (trigger) {
          triggerGone = trigger.getBoundingClientRect().bottom < 0;
        }
        if (productPanel) {
          var panelRect = productPanel.getBoundingClientRect();
          panelVisible = panelRect.top < window.innerHeight && panelRect.bottom > 0;
        }
        stickyBuy.classList.toggle('is-visible', triggerGone && !panelVisible);
      }

      listeners.on(window, 'scroll', syncStickyBuy, { passive: true });
      listeners.on(window, 'resize', syncStickyBuy);
      syncStickyBuy();
    }

    if (variantSelect) {
      setActiveVariantButton(variantSelect.value);
    }
    ensureGalleryControls();
    setQuantity(getQuantity());
    syncBuyNow({ updateGallery: true });
  }

  function initFloatingAtc(bar) {
    if (!bar) return;
    if (bar.dataset.icpFloatingAtcInitialized === 'true') return;
    bar.dataset.icpFloatingAtcInitialized = 'true';
    var listeners = createListenerScope(bar, '__icpFloatingAtcCleanup', 'icpFloatingAtcInitialized');
    var trigger = document.querySelector('[data-icp-sticky-trigger]');

    function syncFloatingAtc() {
      var shouldShow = true;
      if (trigger) {
        shouldShow = trigger.getBoundingClientRect().bottom <= window.innerHeight;
      }
      bar.classList.toggle('is-visible', shouldShow);
    }

    listeners.on(window, 'scroll', syncFloatingAtc, { passive: true });
    listeners.on(window, 'resize', syncFloatingAtc);
    syncFloatingAtc();
  }

  // The cards are a CSS grid on desktop and a Swiper carousel on mobile. The
  // theme's own <slide-section> only toggles Swiper at 767.98px, but this design
  // carousels up to 991.98px, so the instance is driven here instead. The Swiper
  // markup and the section-swiper controls are the theme's; only the breakpoint
  // is ours.
  var CARDS_MQ = '(max-width: 991.98px)';

  function initCardCarousel(section) {
    if (!section) return;
    if (section.dataset.icpCardCarouselInitialized === 'true') return;
    var swiperEl = section.querySelector('[data-icp-cards-swiper]');
    if (!swiperEl) return;
    section.dataset.icpCardCarouselInitialized = 'true';
    var listeners = createListenerScope(section, '__icpCardCarouselCleanup', 'icpCardCarouselInitialized');

    var instance = null;

    function buildOptions() {
      // Gap is per card-style (stats 24px, others 16px); the stylesheet holds
      // it in a custom property so the value lives in one place.
      var gap = parseFloat(getComputedStyle(swiperEl).getPropertyValue('--sa-icp-swiper-gap')) || 16;
      var prevEl = swiperEl.querySelector('.swiper-button-prev');
      var nextEl = swiperEl.querySelector('.swiper-button-next');
      var pagingEl = swiperEl.querySelector('.swiper-pagination');
      var options = {
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: gap,
        loop: false,
        rewind: false,
        watchOverflow: true
      };
      if (prevEl && nextEl) {
        options.navigation = { prevEl: prevEl, nextEl: nextEl };
      }
      if (pagingEl) {
        options.pagination = { el: pagingEl, type: 'progressbar' };
      }
      return options;
    }

    function createInstance() {
      if (instance || typeof window.Swiper !== 'function') return;
      instance = new window.Swiper(swiperEl, buildOptions());
    }

    function destroyInstance() {
      if (instance && typeof instance.destroy === 'function' && !instance.destroyed) {
        instance.destroy(true, true);
      }
      instance = null;
    }

    var mq = window.matchMedia(CARDS_MQ);
    function sync() {
      if (mq.matches) {
        createInstance();
      } else {
        destroyInstance();
      }
    }

    // Swiper library loads deferred too; if it isn't ready yet, retry once.
    if (mq.matches && typeof window.Swiper !== 'function') {
      var retry = window.setTimeout(sync, 300);
      listeners.addCleanup(function () { window.clearTimeout(retry); });
    }

    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', sync);
      listeners.addCleanup(function () { mq.removeEventListener('change', sync); });
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(sync);
      listeners.addCleanup(function () { mq.removeListener(sync); });
    }
    listeners.addCleanup(destroyInstance);
    sync();
  }

  function initAll() {
    document.querySelectorAll('[data-icp-product]').forEach(initIcpProduct);
    document.querySelectorAll('[data-icp-floating-atc]').forEach(initFloatingAtc);
    document.querySelectorAll('.sa-icp-section').forEach(initCardCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:unload', function (event) {
    cleanupIcpSection(event.target);
  });
})();
